import { all, call, put, takeEvery } from "redux-saga/effects"

import {
  POST_WHITELISTED_BRAND_LOGIN,
  GET_WHITELISTED_BRANDS,
  CREATE_WHITELISTED_BRAND,
  DELETE_WHITELISTED_BRAND,
  UPDATE_WHITELISTED_BRAND,
  GET_WHITELISTED_BRANDS_USER_MAPPINGS,
  UPDATE_WHITELISTED_BRANDS_USER_MAPPING,
  GET_WHITELISTED_BRANDS_ADMIN_USERS,
  UPDATE_WHITELISTED_BRANDS_ADMIN_USERS
} from "./actionTypes"

import {
  postWhitelistedBrandLoginSuccess,
  postWhitelistedBrandLoginError,
  getWhitelistedBrandsSuccess,
  getWhitelistedBrandsError,
  createWhitelistedBrandSuccess,
  createWhitelistedBrandError,
  updateWhitelistedBrandSuccess,
  updateWhitelistedBrandError,
  deleteWhitelistedBrandSuccess,
  deleteWhitelistedBrandError,
  getWhitelistedBrandsUserMappingsSuccess,
  getWhitelistedBrandsUserMappingsError,
  updateWhitelistedBrandsUserMappingSuccess,
  updateWhitelistedBrandsUserMappingError,
  getWhitelistedBrandsAdminUsersError,
  getWhitelistedBrandsAdminUsersSuccess,
  updateWhitelistedBrandsAdminUsersSuccess,
  updateWhitelistedBrandsAdminUsersError
} from "./actions"

import { genericDeleteRequest, genericGetRequest, genericPostRequest, genericPutRequest, postJwtAdminLogin } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails, bsh_setInsuranceIoUserDetails } from "helpers/sf_browser_storage_helper"
import { LOGIN_AS_USER_KEY } from "helpers/sf_constants"

function* onWhitelistedBrandLogin(action) {
  try {
    let adminUserInfo = bsh_getAdminUserDetails();
    let data = {
      ...action?.payload?.whitelisted_brand,
      admin_user: action?.payload?.admin_user,
      is_master: action?.payload?.is_master,
      token: adminUserInfo.token,
      whitelisted_brand_id: action?.payload?.whitelisted_brand?.id
    }
    const URL = `${data?.api_url}/api/v1/admin_login`;
    const response = yield call(postJwtAdminLogin, URL, data)

    bsh_setInsuranceIoUserDetails({ token: adminUserInfo.token });

    yield put(postWhitelistedBrandLoginSuccess(response.data));
    window.open(`${data?.admin_portal_url}/login?access_user_token=${adminUserInfo.token}&${LOGIN_AS_USER_KEY.ACCESS_ADMIN_TOKEN}=${response?.data?.token}&insurance_io_user_token=${adminUserInfo.token}`, "_blank");
  } catch (error) {
    if (error) {
      // history.push("/")
    }
    yield put(postWhitelistedBrandLoginError(error))
  }
}

function* onGetWhitelistedBrands() {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_whitelisted_brands`,
      {}, // no query parameters
      {
        Authorization: user.token,
      }
    )
    yield put(getWhitelistedBrandsSuccess(response))
  } catch (error) {
    yield put(getWhitelistedBrandsError(error))
  }
}

function* onCreateWhitelistedBrand(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_whitelisted_brands`;
    const payload = {
      body: JSON.stringify({
        ...action.payload
      }),
      headers: {
        "Authorization": user.token,
        'Content-Type': 'application/json'
      }
    }
    const response = yield call(genericPostRequest, URL, payload)
    yield put(createWhitelistedBrandSuccess(response))
  } catch (error) {
    yield put(createWhitelistedBrandError(error))
  }
}

function* onUpdateWhitelistedBrand(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_whitelisted_brands/${action?.payload?.id}`;
    const payload = {
      body: JSON.stringify({
        ...action.payload
      }),
      headers: {
        Authorization: user.token,
        'Content-Type': 'application/json'
      }
    }
    const response = yield call(genericPutRequest, URL, payload)
    yield put(updateWhitelistedBrandSuccess(response))
  } catch (error) {
    yield put(updateWhitelistedBrandError(error))
  }
}

function* onDeleteWhitelistedBrand(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_whitelisted_brands/${action?.payload?.id}`;
    const response = yield call(
      genericDeleteRequest,
      URL,
      {
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(deleteWhitelistedBrandSuccess(response))
  }
  catch (error) {
    yield put(deleteWhitelistedBrandError(error))
  }
}

function* onGetWhitelistedBrandsUserMappings() {
  try {
    let user = bsh_getAdminUserDetails();
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/get_all_user_mappings`,
      {}, // no query parameters
      {
        Authorization: user.token,
      }
    )
    yield put(getWhitelistedBrandsUserMappingsSuccess(response))
  } catch (error) {
    yield put(getWhitelistedBrandsUserMappingsError(error))
  }
}

function* fetchBrandUsers(brand, admin_user) {
  try {
    const response = yield call(
      genericGetRequest,
      `${brand.api_url}/api/v1/whitelisted_brand_admin_users`,
      {},
      {
        Authorization: admin_user.token,
        "is-master": 1,
        'Content-Type': 'application/json',
        "master-token": admin_user?.token
      }
    );
    return { ...brand, users: response };
  } catch (error) {
    return { ...brand, users: [] };
  }
}

function* onGetWhitelistedBrandsAdminUsers(action) {
  try {
    const admin_user = bsh_getAdminUserDetails();

    const fetchTasks = action.payload.map(brand => call(fetchBrandUsers, brand, admin_user));

    const results = yield all(fetchTasks);

    yield put(getWhitelistedBrandsAdminUsersSuccess(results));
  } catch (error) {
    yield put(getWhitelistedBrandsAdminUsersError(error));
  }
}

function* onUpdateWhitelistedBrandsAdminUsers(action) {
  try {
    const admin_user = bsh_getAdminUserDetails();
    const URL = `${action?.payload?.admin_user?.brand_url}/api/v1/whitelisted_brand_admin_users/${action?.payload?.admin_user?.id}`;
    const payload = {
      body: JSON.stringify({
        ...action.payload
      }),
      headers: {
        Authorization: admin_user.token,
        "is-master": 1,
        'Content-Type': 'application/json',
        "master-token": admin_user?.token
      }
    }
    const response = yield call(genericPutRequest, URL, payload)
    yield put(updateWhitelistedBrandsAdminUsersSuccess({brand_id: action?.payload?.admin_user?.brand_id, admin_user: response}))
  } catch (error) {
    yield put(updateWhitelistedBrandsAdminUsersError(error))
  }
}

function* onUpdateWhitelistedBrandsUserMapping(action) {
  try {
    let user = bsh_getAdminUserDetails();
    const URL = `${AppConfiguration.BACKEND_URL}/api/v1/update_user_mapping`;
    const payload = {
      body: JSON.stringify({
        ...action.payload
      }),
      headers: {
        Authorization: user.token,
        'Content-Type': 'application/json'
      }
    }
    const response = yield call(genericPutRequest, URL, payload)
    yield put(updateWhitelistedBrandsUserMappingSuccess(response))
  } catch (error) {
    yield put(updateWhitelistedBrandsUserMappingError(error))
  }
}

function* whitelistedBrandLoginSaga() {
  yield takeEvery(POST_WHITELISTED_BRAND_LOGIN, onWhitelistedBrandLogin)
  yield takeEvery(GET_WHITELISTED_BRANDS, onGetWhitelistedBrands)
  yield takeEvery(CREATE_WHITELISTED_BRAND, onCreateWhitelistedBrand)
  yield takeEvery(UPDATE_WHITELISTED_BRAND, onUpdateWhitelistedBrand)
  yield takeEvery(DELETE_WHITELISTED_BRAND, onDeleteWhitelistedBrand)
  yield takeEvery(GET_WHITELISTED_BRANDS_USER_MAPPINGS, onGetWhitelistedBrandsUserMappings)
  yield takeEvery(GET_WHITELISTED_BRANDS_ADMIN_USERS, onGetWhitelistedBrandsAdminUsers)
  yield takeEvery(UPDATE_WHITELISTED_BRANDS_ADMIN_USERS, onUpdateWhitelistedBrandsAdminUsers)
  yield takeEvery(UPDATE_WHITELISTED_BRANDS_USER_MAPPING, onUpdateWhitelistedBrandsUserMapping)
}

export default whitelistedBrandLoginSaga;
